// File: client/src/variants/classic/index.js
//
// Classic Chess as a platform plugin. It is deliberately minimal: no runtime, no
// middleware, no UI extensions, standard win conditions. This proves the framework
// imposes ZERO overhead on plain chess — the host renders GameScreen with an empty
// middleware just as before.

import rulebook from './rulebook';

const classicVariant = {
  id: 'classic',
  name: 'Classic Chess',
  tagline: 'The timeless game. Standard rules, no surprises.',
  icon: '♟️',
  accent: 'from-slate-600 to-slate-700',
  supportedGameTypes: ['ai', 'local', 'online'],
  order: 0,
  rulebook,
  // No createController -> the contract normaliser supplies a null runtime, so the
  // host uses the engine's default behaviour end to end.
};

export default classicVariant;
